module.exports = __webpack_public_path__ + "31bb09ef8bcd51a7fffe4ff7abfa0bc3.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_1_0.woff2
// module id = 531
// module chunks = 0